export default "__VITE_ASSET__OJwlCEbZ__"